/** Maps theme `border_color` DB values to CSS colors (dynamic Tailwind classes are not compiled). */
const TAILWIND_COLOR_MAP = {
  'gray-300': '#d1d5db',
  'gray-400': '#9ca3af',
  'gray-500': '#6b7280',
  'gray-600': '#4b5563',
  'gray-700': '#374151',
  'gray-800': '#1f2937',
  'stone-200': '#e7e5e4',
  'stone-300': '#d6d3d1',
  'stone-400': '#a8a29e',
  'stone-500': '#78716c',
  'stone-600': '#57534e',
  'stone-700': '#44403c',
  'stone-800': '#292524',
  'amber-200': '#fde68a',
  'amber-300': '#fcd34d',
  'amber-400': '#fbbf24',
  'amber-600': '#d97706',
  'amber-700': '#b45309',
  'amber-800': '#92400e',
  'yellow-200': '#fef08a',
  'yellow-700': '#a16207',
};

function normalizeBorderColorKey(value) {
  return String(value || '')
    .trim()
    .replace(/^bg-/, '')
    .replace(/^border-/, '');
}

export function resolvePageThemeAccentColor(borderColor) {
  if (!borderColor) {
    return '#a8a29e';
  }
  const trimmed = String(borderColor).trim();
  if (trimmed.startsWith('#')) {
    return trimmed;
  }
  const key = normalizeBorderColorKey(trimmed);
  return TAILWIND_COLOR_MAP[key] || '#a8a29e';
}

function darkenHex(hex, factor = 0.28) {
  const raw = hex.replace('#', '');
  if (raw.length !== 6) {
    return '#57534e';
  }
  const r = parseInt(raw.slice(0, 2), 16);
  const g = parseInt(raw.slice(2, 4), 16);
  const b = parseInt(raw.slice(4, 6), 16);
  const scale = 1 - factor;
  const toByte = (n) => Math.max(0, Math.min(255, Math.round(n * scale)));
  return `#${[toByte(r), toByte(g), toByte(b)]
    .map((n) => n.toString(16).padStart(2, '0'))
    .join('')}`;
}

export function getPageThemeChrome(theme) {
  const accentColor = resolvePageThemeAccentColor(theme?.border_color);
  return {
    accentColor,
    bindingColor: darkenHex(accentColor, 0.42),
    surfaceFallback: '#f5f5f4',
  };
}
